import './App.css';
import Swap from './components/swap/Swap';

function App() {
  return (
    <div className='stack'>
      <Swap />
    </div>
  );
}

export default App;
